export default __webpack_public_path__ + "static/stanleyknife-6a1cdf1cfa9ea039fd81bb0d25b05d11.png";